import React, { useEffect, useState } from "react";
import { getCommonConfig, updateCommonConfig } from "@/services/commonconfig";

const PartnerDirectoryConfig: React.FC = () => {
  const [configData, setConfigData] = useState<any>({});
  const [savedConfig, setSavedConfig] = useState<any>(null);
  const [saving, setSaving] = useState(false);

  const [partnerDirectoryFluxxUrl1, setPartnerDirectoryFluxxUrl1] =
    useState("");
  const [partnerDirectoryFluxxUrl2, setPartnerDirectoryFluxxUrl2] =
    useState("");

  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    const config = await getCommonConfig();

    setConfigData(config);
    setSavedConfig(config);

    setPartnerDirectoryFluxxUrl1(
      config?.PartnerDirectoryFluxx1 || ""
    );
    setPartnerDirectoryFluxxUrl2(
      config?.PartnerDirectoryFluxx2 || ""
    );
  };

  const hasChanges =
    !!savedConfig &&
    (
      partnerDirectoryFluxxUrl1 !==
        (savedConfig.PartnerDirectoryFluxx1 || "") ||
      partnerDirectoryFluxxUrl2 !==
        (savedConfig.PartnerDirectoryFluxx2 || "")
    );

  const handleSave = async () => {
    setSaving(true);

    try {
      const payload = {
        ...configData,
        PartnerDirectoryFluxx1: partnerDirectoryFluxxUrl1,
        PartnerDirectoryFluxx2: partnerDirectoryFluxxUrl2,
      };

      await updateCommonConfig(payload);

      setConfigData(payload);
      setSavedConfig(payload);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    if (!savedConfig) return;

    setConfigData(savedConfig);

    setPartnerDirectoryFluxxUrl1(
      savedConfig.PartnerDirectoryFluxx1 || ""
    );

    setPartnerDirectoryFluxxUrl2(
      savedConfig.PartnerDirectoryFluxx2 || ""
    );
  };

  return (
    <div className="border border-gray-200 rounded-md bg-[#fbfaf7] p-3 space-y-3">
      <div className="flex items-center gap-4 text-xs">
        <span className="w-44 text-gray-700">
          Fluxx URL (for each record)
        </span>

        <input
          type="text"
          value={partnerDirectoryFluxxUrl1}
          onChange={(e) =>
            setPartnerDirectoryFluxxUrl1(e.target.value)
          }
          className="flex-1 border border-gray-300 rounded px-3 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-[var(--color-brand)]"
          placeholder="Enter Fluxx URL"
        />
      </div>

      <div className="flex items-center gap-4 text-xs">
        <span className="w-44 text-gray-700">
          Fluxx URL (view in Fluxx)
        </span>

        <input
          type="text"
          value={partnerDirectoryFluxxUrl2}
          onChange={(e) =>
            setPartnerDirectoryFluxxUrl2(e.target.value)
          }
          className="flex-1 border border-gray-300 rounded px-3 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-[var(--color-brand)]"
          placeholder="Enter Fluxx URL"
        />
      </div>

      <div className="flex justify-end gap-2 items-center pt-2">
        {hasChanges && (
          <div className="text-orange-600 border border-orange-300 bg-orange-50 px-2 py-0.5 rounded text-xs">
            Unsaved
          </div>
        )}

        <button
          className="bg-[#e7e5e0] px-3 py-1 text-xs"
          onClick={handleCancel}
          disabled={!hasChanges}
        >
          Cancel
        </button>

        <button
          className="bg-[var(--color-brand)] text-white px-3 py-1 text-xs"
          onClick={handleSave}
          disabled={!hasChanges || saving}
        >
          {saving ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default PartnerDirectoryConfig;